import http from "@/http-common";

const BASE = "statistics/news";

class NewsStatisticsService {
  getOverview() {
    return http.get(`${BASE}/overview`);
  }

  getLatest(scope) {
    return http.get(`${BASE}/latest`, { params: { scope } });
  }
}

export default new NewsStatisticsService();
